// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1L8Bh","search":"Settings_search__2tuxP","filter":"Settings_filter__2yXId"};